import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import { DateTimeHelperService } from '../../utils/forms/datetime-helper.service';

export interface VertragsbeginnConstraints {
  earliestVertragsbeginn: string;
  antragstellerFristTag: number;
  vkuStichtagTag: number;
}

@Injectable({providedIn: 'root'})
export class VertragsbeginnConstraintsService {
  
    readonly http = inject(HttpClient);
    
  private readonly constraints$: Observable<VertragsbeginnConstraints> = this.http
    .get<VertragsbeginnConstraints>('api/antrag-ticket/vertragsbeginn-constraints')
    .pipe(shareReplay({bufferSize: 1, refCount: true}));

  getConstraints(): Observable<VertragsbeginnConstraints> {
    return this.constraints$;
  }
}
